import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledMessagePageGridContainerBox = styled(Grid) `
	padding: ${Magnetic.spacer08} ${Magnetic.spacer20};
	width: 100%;
	margin: auto;
	background-color: ${Magnetic.colorNeutral30};
	border-radius: ${Magnetic.spacer06};
	font-weight: ${Magnetic.fontWeightSemibold};
	text-align: center;
`;
export const StyledMessagePageGridContainerItem = styled(Grid) `
	padding: ${Magnetic.spacer08} 0px;
`;
export const StyledMessagePageContainer = styled.div `
	display: flex;
	gap: 80px;
	align-items: center;
	flex-direction: column;
	margin-top: 24px;
`;
export const StyledMessagePageSecondaryContainer = styled.div `
	display: flex;
	width: 100%;
	align-items: center;
`;
//# sourceMappingURL=IntelligentPhotoCaptureShowMessagePage.style.js.map